import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { RuleArgs } from '.';

export const paymentCommentRule = ({ required }: RuleArgs): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct payment comment'),
    required,
    min: 1,
    max: 1024,
  });
};
